// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"201":"91a5c918996a0146","888":"168e4a3444e96b5f"}[chunkId] + ".css";
};